module.exports = __webpack_public_path__ + "static/media/MACCS_Poster.478aeda7.pdf";